import { render, staticRenderFns } from "./Add.vue?vue&type=template&id=5a1d9d22"
import script from "./Add.vue?vue&type=script&lang=ts"
export * from "./Add.vue?vue&type=script&lang=ts"
import style0 from "./Add.vue?vue&type=style&index=0&id=5a1d9d22&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports